import "./ComponentsStyles/Footer.css";
import logo2 from "../Assets/logo.png";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaYoutube,
} from "react-icons/fa";

import { ImLocation2 } from "react-icons/im";
import { Link, useNavigate } from "react-router-dom";

export default function FooterSection() {
  const navigate = useNavigate();
  const handleCenterClick = () => {
    navigate("/contact-us");
  };
  const handleReportClick = () => {
    navigate("/view-reports");
  };
  const handleNewsClick = () => {
    navigate("/news");
  };
  const handleOverviewClick = () => {
    navigate("/overview");
  };
  const handleDisclaimerClick = () => {
    navigate("/disclaimer");
  };
  const handleContactClick = () => {
    navigate("/contact");
  };
  const handleAccountDelectionClick = () => {
    navigate("/account-delete");
  };

  const handleTermsAndConditionClick = () => {
    navigate("/TermsAndCondition");
  };

  const handlePrivacyPolicyClick = () => {
    navigate("/privacy-policy");
  };

  const handlePaymentRefundPolicyClick = () => {
    navigate("/paymentRefundPolicy");
  };

  const handlerClick = () => {
    navigate("/radiology");
  };

  const handleRadiologyClick = () => {
    navigate("/radiologyFooter");
  };
  const handleCareerClick = () => {
    navigate("/Career");
  }
  return (
    <>
      <footer className="footer">

        <div className="footer-container">
          <div className="footer-content-logo">
            <div className="footerLogo">
              <Link to="/">
                <img src={logo2} alt="RB Logo" className="logo" />
              </Link>
            </div>
          </div>
          <div className="footer-left">
            {/* <h3 className="headingText">Short Links</h3>
            <div className="underLine"></div> */}
            <div className="contactDiv">
              <h3 className="headingText">Short Links</h3>
              <div className="underLine"></div>
            </div>
            <div className="short-links">
              <ul>
                <li onClick={handleNewsClick} style={{ cursor: "pointer" }}>
                  News
                </li>
                <li onClick={handleOverviewClick} style={{ cursor: "pointer" }}>
                  Overview
                </li>
                <li onClick={handleContactClick} style={{ cursor: "pointer" }}>
                  Contact
                </li>
                <li
                  onClick={handleDisclaimerClick}
                  style={{ cursor: "pointer" }}
                >
                  Disclaimer
                </li>
              </ul>
              <ul>
                <li
                  onClick={handleTermsAndConditionClick}
                  style={{ cursor: "pointer" }}
                >
                  Terms & Conditions
                </li>
                <li
                  onClick={handlePrivacyPolicyClick}
                  style={{ cursor: "pointer" }}
                >
                  Privacy & Policy
                </li>
                <li
                  onClick={handlePaymentRefundPolicyClick}
                  style={{ cursor: "pointer" }}
                >
                  Payment & Refund Policy
                </li>
                <li
                  onClick={handleAccountDelectionClick}
                  style={{ cursor: "pointer" }}
                >
                  Account Deletion Request
                </li>
              </ul>
              <ul>
                <li onClick={handleCenterClick} style={{ cursor: "pointer" }}>
                  Centers
                </li>
                <li onClick={handleCareerClick} style={{ cursor: "pointer" }}>
                  Career
                </li>
                <li onClick={handleRadiologyClick} style={{ cursor: "pointer" }}>Radiology Images</li>
                <li onClick={handleReportClick} style={{ cursor: "pointer" }}>
                  Online Report
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-right">
            <div className="contactDiv">
              <h3 className="headingText">Contact Us</h3>
              <div className="underLine"></div>
            </div>

            <ul className="contact-info">
              <li>
                <FaPhoneAlt /> 033-4085 4085 / 033-3382 3382
              </li>
              <li>
                <FaEnvelope /> info@rbdiagnostics.com
              </li>
              <li>
                <ImLocation2 className="locationPinIcon" />R B Diagnostics (P)
                Ltd, P-846 Block A, Lake Town, Kolkata-700089
                <br />
                Landmark: Near Bank Of Baroda Laketown
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="social-icons">
            <a
              href="https://www.facebook.com/rbdiagnostic/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook size={20} />
            </a>
            <a
              href="https://x.com/diagnosticrb"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter size={20} />
            </a>
            <a
              href="https://www.linkedin.com/company/rb-diagnostic/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin size={20} />
            </a>
            <a
              href="https://www.youtube.com/channel/UCmWvEtwmvFg9JvwcUq26YNg"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube size={20} />
            </a>
          </div>
          <p
            style={{
              fontSize: "11px",
            }}
          >
            © Copyright @2021 RB Diagnostic Pvt. Ltd. (India) <br />
            {/* Designed & Developed by EsspeSoft. */}
          </p>
        </div>
      </footer>
    </>
  );
}
